import type { TrailDefinition, TrailContext } from './types'

interface Particle {
  x: number
  y: number
  vx: number
  vy: number
  life: number
  maxLife: number
  size: number
  rotation: number
  rotationSpeed: number
}

const MAX_PARTICLES = 80

export const sparkles: TrailDefinition = {
  id: 'sparkles',
  name: 'Sparkles',

  init() {
    return [] as Particle[]
  },

  update(state: unknown, ctx: TrailContext) {
    const particles = state as Particle[]
    const dt = ctx.deltaTime / 1000

    // Spawn new particles at mouse position
    if (ctx.mouseActive && dt > 0) {
      const spawnCount = Math.min(3, MAX_PARTICLES - particles.length)
      for (let i = 0; i < spawnCount; i++) {
        const angle = Math.random() * Math.PI * 2
        const speed = 30 + Math.random() * 60
        particles.push({
          x: ctx.mouseX + (Math.random() - 0.5) * 8,
          y: ctx.mouseY + (Math.random() - 0.5) * 8,
          vx: Math.cos(angle) * speed,
          vy: Math.sin(angle) * speed,
          life: 1,
          maxLife: 0.4 + Math.random() * 0.4,
          size: 1.5 + Math.random() * 2.5,
          rotation: Math.random() * Math.PI * 2,
          rotationSpeed: (Math.random() - 0.5) * 8
        })
      }
    }

    // Update existing particles
    for (let i = particles.length - 1; i >= 0; i--) {
      const p = particles[i]
      p.life -= dt / p.maxLife
      p.x += p.vx * dt
      p.y += p.vy * dt
      p.vy += 20 * dt // slight gravity
      p.vx *= 0.98
      p.vy *= 0.98
      p.rotation += p.rotationSpeed * dt

      if (p.life <= 0) {
        particles.splice(i, 1)
      }
    }
  },

  draw(state: unknown, ctx: TrailContext) {
    const particles = state as Particle[]
    const c = ctx.ctx

    for (const p of particles) {
      const alpha = Math.max(0, p.life)
      const size = p.size * (0.5 + alpha * 0.5)

      c.save()
      c.translate(p.x, p.y)
      c.rotate(p.rotation)
      c.globalAlpha = alpha

      // Draw a 4-point star
      c.beginPath()
      const outer = size
      const inner = size * 0.3
      for (let i = 0; i < 4; i++) {
        const angle = (i / 4) * Math.PI * 2 - Math.PI / 2
        const nextAngle = ((i + 0.5) / 4) * Math.PI * 2 - Math.PI / 2
        c.lineTo(Math.cos(angle) * outer, Math.sin(angle) * outer)
        c.lineTo(Math.cos(nextAngle) * inner, Math.sin(nextAngle) * inner)
      }
      c.closePath()
      c.fillStyle = `rgba(255, 255, 220, 1)`
      c.fill()

      // Glow
      c.shadowColor = 'rgba(255, 240, 180, 0.8)'
      c.shadowBlur = size * 3
      c.fill()

      c.restore()
    }
    c.globalAlpha = 1
  }
}
